import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Factory, Building2 } from "lucide-react";

const notes = [
  { icon: ShieldCheck, label: "Verified Suppliers" },
  { icon: Factory, label: "Factory Direct" },
  { icon: Building2, label: "Enterprise Confidence" },
];

export const FinalCTA = () => {
  return (
    <section id="final-cta" data-testid="final-cta-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[2rem] bg-[#0F172A] px-6 sm:px-12 lg:px-16 py-16 sm:py-20">
          <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-blue-600/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-blue-500/10 blur-3xl" />
          <div className="relative max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-xs font-bold tracking-[0.18em] uppercase text-blue-300"><span className="w-1.5 h-1.5 rounded-full bg-blue-400" />Workspace Product</span>
            <h2 className="mt-6 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-[1.1] text-white">Start sourcing from trusted Turkish manufacturers.</h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed">Discover verified manufacturers, reduce supplier risk and build stronger sourcing relationships through the DeMaxtore Workspace.</p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <a href="#suppliers" data-testid="final-primary-cta" className="bg-blue-600 text-white rounded-full px-7 py-4 text-sm sm:text-base font-medium hover:bg-blue-500 transition-all duration-300 shadow-[0_10px_30px_rgba(37,99,235,0.35)] hover:-translate-y-0.5 inline-flex items-center justify-center gap-2 group">
                Explore Verified Manufacturers
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <a href="#top" data-testid="final-secondary-cta" className="bg-white/5 text-white border border-white/15 rounded-full px-7 py-4 text-sm sm:text-base font-medium hover:bg-white/10 transition-all duration-300 inline-flex items-center justify-center gap-2">Create Your Free Workspace</a>
            </div>
            <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
              {notes.map((n) => (<span key={n.label} className="flex items-center gap-2 text-sm font-medium text-slate-300"><n.icon className="w-4 h-4 text-emerald-400" />{n.label}</span>))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
